/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Position_Y_Offset_TooltipInputs */



/**
* | output |
* | --- |
* | "Check for Events where the vertical offset is set" |
*
* @param {Style_Guide_Manager_Position_Y_Offset_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_position_y_offset_tooltip = /** @type {((inputs?: Style_Guide_Manager_Position_Y_Offset_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Position_Y_Offset_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verifier les evenements ou le decalage vertical est defini")
	if (locale === "de") return /** @type {LocalizedString} */ ("Prüfen Sie, ob Ereignisse ausgewählt sind, bei denen der vertikale Versatz festgelegt ist.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controlla gli eventi in cui è impostato lo spostamento verticale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проверьте события, в которых задано вертикальное смещение.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comprobar eventos en los que se establece el desplazamiento vertical")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("检查设置了垂直偏移量的事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("垂直オフセットが設定されているイベントを確認する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उन इवेंट्स की जाँच करें जहाँ वर्टिकल ऑफ़सेट सेट किया गया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Verifique os eventos em que o deslocamento vertical está definido.")
	return /** @type {LocalizedString} */ ("Check for Events where the vertical offset is set")
});